// extracted by mini-css-extract-plugin
module.exports = {"testCaseSetContainer":"ExerciseOverviewPage_testCaseSetContainer__26KON","sidebar":"ExerciseOverviewPage_sidebar__2TVvy"};